export function onThemeChange(themeMode) {
  return {
    type: "ON_THEME_CHANGE",
    themeMode,
  };
}
